import { render, staticRenderFns } from "./CategoryPost.vue?vue&type=template&id=48902bb9&scoped=true&lang=pug&"
import script from "./CategoryPost.vue?vue&type=script&lang=js&"
export * from "./CategoryPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48902bb9",
  null
  
)

export default component.exports